import React from "react";
import { Box, Typography } from "@mui/material";
import FAIRModelVisualization from "../../../../components/charts/FairModel";
import { useTranslation } from "react-i18next";

export default function AleExport({ data }) {
  const formatCurrency = (value) => {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });
  };
  const { t } = useTranslation();

  return (
    <Box sx={{ bgcolor: "#f9f9f9", fontSize: "0.875rem" }}>
      <Box
        sx={{
          //   height: "297mm", // A4 height
          width: "210mm", // A4 width
          margin: "auto", // Center the box horizontally
          marginBottom: "20px",
          pageBreakAfter: "always", // Ensure each box starts on a new page in the PDF
          boxShadow: 3,
          borderRadius: 2,
          bgcolor: "#f9f9f9",

          boxSizing: "border-box", // Include padding in the total width/height
          overflow: "hidden", // Prevent content from overflowing
        }}
      >
        {data.map((item, index) => (
          <Box
            key={index}
            id={`tlm-threat-${index}`}
            sx={{
              width: "210mm",
              margin: "auto",
              marginBottom: "16px",
              pageBreakAfter: "always",
              boxShadow: 2,
              borderRadius: 2,
              bgcolor: "#f9f9f9",
              padding: "16px",
              boxSizing: "border-box",
              overflow: "hidden",
            }}
          >
            {index === 0 && (
              <Box id="text-section">
                <Typography
                  sx={{
                    textAlign: "start",
                    marginBottom: "10px",
                    fontWeight: "bold",
                  }}
                  variant="h5"
                >
                  Section 5 : Risk Quantification
                </Typography>

                <Typography
                  sx={{
                    textAlign: "start",
                    fontSize: "0.875rem",
                    marginBottom: "10px",
                  }}
                >
                  {`Risk Quantification presents the results of our risk analysis using the Factor Analysis of Information Risk (FAIR) model. This industry-standard approach quantifies cybersecurity risk in financial terms, providing a clear and actionable metric for decision-makers.
 
                                    The key metric presented here is the Annual Loss Expectancy (ALE), which represents the anticipated yearly financial impact of a given threat scenario. ALE is calculated by combining two critical components: Loss Event Frequency (LEF), which estimates how often a loss event may occur in a year, and Loss Magnitude (LM), which quantifies the potential financial impact of a single event.
 
                                    For each threat scenario, we have conducted 10,000 Monte Carlo simulations, as prescribed by the FAIR model methodology. This approach allows us to account for the inherent uncertainties in risk assessment and provides a robust statistical foundation for our estimates. The graphs presented for each threat scenario depict the mean ALE value derived from these simulations, offering a balanced view of potential risk exposure.
 
                                    It's important to emphasize that our analysis strictly adheres to the FAIR model methodology and best practices. This ensures that our risk quantification is not only comprehensive but also aligns with industry-recognized standards for cybersecurity risk assessment. By following this rigorous approach, we provide a solid foundation for informed decision-making and strategic risk management.`.replace(
                    /\. /g,
                    ".\n\n"
                  )}
                </Typography>
              </Box>
            )}

            <Typography
              id="text-section"
              sx={{
                textAlign: "start",
                fontWeight: "bold",
              }}
              variant="h6"
            >
              5.{index + 1} {t(item["threat"])} Attack Scenario
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: 1,
                mt: 2,
                px: { xs: 1, sm: 2 },
              }}
            >
              <Box
                id="graph-section"
                sx={{
                  boxShadow: 2,
                  borderRadius: 2,
                  p: 2,
                  bgcolor: "background.paper",
                  width: "90%",
                  minHeight: "300px",
                  height: "auto",
                  textAlign: "center",
                }}
              >
                <FAIRModelVisualization
                  data={{
                    mother: item["ale_mean"],
                    child1: item["tlm_mean"],
                    child2: item["lef_mean"],
                  }}
                />
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: 1,
                mt: 2,
                px: { xs: 1, sm: 2 },
              }}
            >
              <Box
                id="text-section"
                sx={{
                  boxShadow: 2,
                  borderRadius: 2,
                  p: 2,
                  bgcolor: "background.paper",
                  width: "90%",
                  minHeight: "300px",
                  height: "auto",
                  textAlign: "start",
                }}
              >
                <Typography sx={{ fontSize: "0.875rem" }}>
                  {item["justification"]}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
